import Box from '@mui/material/Box';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { theme } from '@omnigenbiodata/ui';
import { SampleKit } from '../../../../../../core/types/common.types';
import Chip from '@mui/material/Chip';

const successTint = theme.palette.success.lighter;

function formatDateTime(value: string) {
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

interface ConfirmedSampleBannerProps {
  sample: SampleKit;
}

function ConfirmedSampleBanner({ sample }: ConfirmedSampleBannerProps) {
  return (
    <Paper
      elevation={2}
      sx={{
        mb: 4,
        border: 1,
        borderColor: 'success.main',
        bgcolor: successTint,
        overflow: 'hidden',
      }}
    >
      <Box p={2.5}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <CheckCircleOutlined color="success" sx={{ fontSize: 32 }} />

          <Typography variant="h6" component="p" sx={{ fontWeight: 700, color: 'primary.main' }}>
            Sample scanned:
          </Typography>

          <Chip label={sample.sampleBarcode} color="success" sx={{ fontWeight: 700 }} />

          {sample.linkDate && (
            <Typography variant="body1" component="p" color="text.secondary">
              Linked {formatDateTime(sample.linkDate)}
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
}

export default ConfirmedSampleBanner;
